import React, { memo, useMemo } from 'react';
import QuickInputArrowIcon from '@/pages/aigc/assets/svg/agent-quick-input-arrow.svg';
import { getBtnButtonList } from '../../utils';

interface IQuickInputBtnCmpProps {
  children?: React.ReactNode;
  isLastQA?: boolean;
  streamingState?: string | null;
  onRecommendClick?: (value: string, isWebSearch?: boolean) => void;
}

const QuickInputBtnCmp = memo((props: IQuickInputBtnCmpProps) => {
  const { children, isLastQA, streamingState, onRecommendClick } = props;

  const buttonList = useMemo(() => getBtnButtonList(children), [children]);

  if (
    !isLastQA ||
    !buttonList.length ||
    (streamingState && ['progressing', 'pending'].includes(streamingState))
  ) {
    return null;
  }

  const handleClick = (query: string): void => {
    onRecommendClick?.(query);
  };

  return (
    <div className="dba-quick-input-btn-wrap">
      {buttonList.map((button, index) => (
        <button
          key={`${button.query}-${index}`}
          type="button"
          className="dba-quick-input-btn"
          onClick={() => handleClick(button.query)}
        >
          <span className="dba-quick-input-btn__text">{button.query}</span>
          <img
            className="dba-quick-input-btn__arrow"
            src={QuickInputArrowIcon}
            alt=""
            aria-hidden
          />
        </button>
      ))}
    </div>
  );
});

QuickInputBtnCmp.displayName = 'QuickInputBtnCmp';

export default QuickInputBtnCmp;
